<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default  {
  name:  'App',
}
</script>

<style>

  .flexRowClass {
    display: flex;
    flex-direction: row;
  }

  .overflowClass {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .scrollYClass {
    overflow: hidden;
    overflow-y: scroll;
  }
</style>
